export const LogoRive = () => {
  return (
    <img
      src="/images/speakalot_logo.PNG"
      alt="Speakalot"
      className="h-[50px] w-[160px] object-contain px-12 2xl:h-[72px] 2xl:w-[230px] 2xl:px-8"
    />
  )
}
